import { IState } from '../types';

import Constants from '../constants';

export default {
  constants: Constants,
  features: {
    ageMatching: false,
    employerMatch: true,
    showUi: true,
  },
  copy: {
    name: 'Lifetime',
    inputs: {
      age: {
        label: 'Age',
        error: 'Please enter an age between',
      },
      income: {
        label: 'Gross annual salary',
        error: 'Please enter an income between',
      },
      payFrequency: {
        label: 'Show results as:',
      },
    },
    outputs: {
      youContribute: 'Your contribution rate',
      totalContributions: 'Total contribution',
      costToYou: 'Actual cost to you',
      employee: 'You contribute',
      employer: 'Your employer contributes',
      niTaxRelief: 'NI and tax relief',
    },
    legend: {
      ni: 'National Insurance (NI) and tax relief',
      employee: 'Your contributions',
      employer: 'Employer contributions',
    },
  },
  ui: {
    version: process.env.VUE_APP_VERSION,
    loading: false,
    precision: {
      percent: 2,
      currency: 0,
    },
    visibleRates: [],
    printing: false,
    ga: '',
    hasChangedAge: false,
    hasChangedIncome: false,
  },
  assumptions: {
    salarySacrifice: true,
    contributionRates: [0.03, 0.04, 0.05],
    calculationDate: null,
    employerMatch: {
      101: {
        employee: [0.03, 0.04, 0.05],
        employer: [0.07, 0.09, 0.11],
      },
    },
  },
  inputs: {
    gender: '',
    age: 0,
    dateOfBirth: '',
    payFrequency: 12,
    income: 0,
    contributionRate: 0,
    preInvestmentReturn: 0.04,
    postInvestmentReturn: 0.04,
  },
} as IState;
